export default __webpack_public_path__ + "static/weu-50033b611140effa6124f84debb1d8e3.png";